import { useTranslation } from "react-i18next";

import BustleWordMark from "../../assets/images/bustle/StackedLockUpCoolBlue@0.5.png";
import { useVenue } from "./VenueContext";

export const ThankYou = () => {
  const { t } = useTranslation("onsite");

  const venue = useVenue();
  return (
    <div className="mx-auto flex h-[90vh] max-w-screen-sm flex-col items-stretch justify-end space-y-96">
      <div className="flex h-[80vh] flex-1 flex-col justify-between space-y-96 text-center">
        <div className="border-y border-dashed border-black py-48 text-5xl font-medium">
          {t("bustleThankyou.servingMoreGoodTimes")}
        </div>
        <div className="space-y-16">
          <div className="flex-none border-y border-dashed border-black py-32 text-2xl font-semibold">
            {t("bustleThankyou.comeAgain")}{" "}
          </div>
          <div className="mx-auto w-96 pb-32">
            <a href="https://heybustle.com">
              <img src={BustleWordMark} />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};
